import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { END, localTimeParts, tzLabel } from "@/components/NetZeroClock";

const CountdownStrip = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const remaining = Math.max(END - now, 0);
  const days = Math.floor(remaining / 86400000);

  const { hh, mm, ss } = localTimeParts(now);
  const tz = tzLabel();

  return (
    <div
      data-testid="countdown-strip"
      className="fixed top-0 inset-x-0 z-[60] h-9 flex items-center justify-center gap-3 bg-gradient-to-r from-lime/15 via-carbon to-cyber/15 border-b border-lime/25 backdrop-blur-xl"
    >
      <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-lime" />
      <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-lime font-semibold">
        Net Zero 2050
      </span>
      <span data-testid="strip-countdown" className="font-mono text-[11px] sm:text-xs text-white tracking-wider">
        {hh}:{mm}:{ss}{tz.short ? ` ${tz.short}` : ""} · {days.toLocaleString()} days left
      </span>
      <Link
        to="/contact"
        data-testid="strip-cta-link"
        className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-lime transition-colors"
      >
        Act now →
      </Link>
    </div>
  );
};

export default CountdownStrip;
